// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__9caoa","img":"Loader_img__q5AE1","white":"Loader_white__-zX4p"};